const actions = {
    FORMS_BEGIN: 'FORMS_BEGIN',
    FORMS_SUCCESS: 'FORMS_SUCCESS',
    FORMS_ERR: 'FORMS_ERR',

    formsBegin: () => {
        return {
            type: actions.FORMS_BEGIN,
        };
    },
    formsSuccess: (data) => {
        return {
            type: actions.FORMS_SUCCESS,
            data,
        };
    },

    formsErr: (err) => {
        return {
            type: actions.FORMS_ERR,
            err,
        };
    },
};
export default actions;
